import { useState, useEffect } from 'react';

/**
 * Query Hivemind for the variant result of a given experiment and set the result to React state
 *
 * @param {Window|Object} target Browser window object or fallback
 * @param {Object} opt Options
 * @param {String} opt.experimentId The experiment ID
 * @param {String} opt.stateFieldName The name of the React state field to store the result in
 * @param {Object} [opt.attributes] An optional object to to pass along attributes
 * for split.io to calculate the variant ID. If none pass {}
 * @returns {Object} experiment settings
 * @public
 */
export function useHivemind(target, { experimentId, stateFieldName, attributes = {} } = {}) {
  const [experiment, setExperiment] = useState(null);

  useEffect(() => {
    if (!target?.hivemind || !experimentId || !stateFieldName) return;
    target.hivemind.getClient().then(client => {
      const { cohorts } = client.getCohorts({
        experiments: [experimentId],
        attributes
      });

      if (!cohorts || !cohorts[experimentId]) return;
      setExperiment({ [stateFieldName]: cohorts[experimentId].cohortId });
    });
  }, [experimentId, stateFieldName, attributes, target?.hivemind]);

  return experiment;
}
